import useDialogState from '@/hooks/use-dialog-state'
import React, { useState } from 'react'

type AgentsDialogType = 'delete'

export interface AgentRow {
  id: number
  name: string
  model: string
  status: string
  language: string
  messageCount: number
  createdAt: string
}

interface AgentsContextType {
  open: AgentsDialogType | null
  setOpen: (str: AgentsDialogType | null) => void
  currentRow: AgentRow | null
  setCurrentRow: React.Dispatch<React.SetStateAction<AgentRow | null>>
  refetch: () => void
}

const AgentsContext = React.createContext<AgentsContextType | null>(null)

interface Props {
  children: React.ReactNode
  refetch: () => void
}

export default function AgentsProvider({ children, refetch }: Props) {
  const [open, setOpen] = useDialogState<AgentsDialogType>(null)
  const [currentRow, setCurrentRow] = useState<AgentRow | null>(null)
  return (
    <AgentsContext value={{ open, setOpen, currentRow, setCurrentRow, refetch }}>
      {children}
    </AgentsContext>
  )
}

// eslint-disable-next-line react-refresh/only-export-components
export const useAgents = () => {
  const agentsContext = React.useContext(AgentsContext)

  if (!agentsContext) {
    throw new Error('useAgents has to be used within <AgentsContext>')
  }

  return agentsContext
}
